import { ReactNode, useEffect, useRef, useState } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useWorkspaceId } from "../bridges/session";
import { createQueryClient } from "./queryClient";

export const QueryProvider = ({ children, client }: { children: ReactNode; client?: QueryClient }) => {
  const [qc] = useState(() => client ?? createQueryClient());
  const ws = useWorkspaceId();
  const prev = useRef(ws);
  useEffect(() => {
    // Only a switch from one account to another; the first null -> id (login/boot) must keep loaded data.
    if (prev.current !== null && prev.current !== ws) qc.clear();
    prev.current = ws;
  }, [ws, qc]);
  return <QueryClientProvider client={qc}>{children}</QueryClientProvider>;
};
